export default function IconSubtractCircle({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <clipPath id="subtract-circle-clip">
        <rect width="16" height="16" fill="white" />
      </clipPath>
      <g clipPath="url(#subtract-circle-clip)">
        <path
          d="M7.99935 15.3337C12.0493 15.3337 15.3327 12.0503 15.3327 8.00033C15.3327 3.95033 12.0493 0.666992 7.99935 0.666992C3.94935 0.666992 0.666016 3.95033 0.666016 8.00033C0.666016 12.0503 3.94935 15.3337 7.99935 15.3337Z"
          fill="#FFBFC5"
        />
        <path
          d="M7.9993 13.3333C9.77131 13.3338 11.4835 12.6926 12.8194 11.5283C14.1552 10.364 15.0243 8.75545 15.266 7C15.4698 8.49912 15.2049 10.0246 14.5077 11.3673C13.8104 12.7099 12.7149 13.804 11.3714 14.4996C10.0279 15.1952 8.50206 15.4582 7.00319 15.2525C5.50433 15.0468 4.10578 14.3825 2.9993 13.3507C2.14099 12.5507 1.48717 11.5564 1.09275 10.4513C0.698335 9.34625 0.574839 8.16268 0.732635 7C0.974272 8.75545 1.84337 10.364 3.17921 11.5283C4.51506 12.6926 6.2273 13.3338 7.9993 13.3333Z"
          fill="#FF808C"
        />
        <path
          d="M7.99935 15.3337C12.0493 15.3337 15.3327 12.0503 15.3327 8.00033C15.3327 3.95033 12.0493 0.666992 7.99935 0.666992C3.94935 0.666992 0.666016 3.95033 0.666016 8.00033C0.666016 12.0503 3.94935 15.3337 7.99935 15.3337Z"
          stroke="#191919"
          strokeWidth="0.666682"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.0007 6.66699H4.00065C3.82384 6.66699 3.65427 6.73723 3.52925 6.86225C3.40422 6.98728 3.33398 7.15685 3.33398 7.33366V8.66699C3.33398 8.8438 3.40422 9.01337 3.52925 9.1384C3.65427 9.26342 3.82384 9.33366 4.00065 9.33366H12.0007C12.1775 9.33366 12.347 9.26342 12.4721 9.1384C12.5971 9.01337 12.6673 8.8438 12.6673 8.66699V7.33366C12.6673 7.15685 12.5971 6.98728 12.4721 6.86225C12.347 6.73723 12.1775 6.66699 12.0007 6.66699Z"
          fill="white"
          stroke="#191919"
          strokeWidth="0.666682"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
